module.exports = __webpack_public_path__ + "static/img/tabs01.dd219573.png";